/**
 * 学期api
 * 学期api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../basic/model/CreatedVo';
import PagingSchoolTermVo from '../../basic/model/PagingSchoolTermVo';
import SchoolTermCreateForm from '../../basic/model/SchoolTermCreateForm';
import SchoolTermEditForm from '../../basic/model/SchoolTermEditForm';
import SchoolTermVo from '../../basic/model/SchoolTermVo';
import UpdatedVo from '../../basic/model/UpdatedVo';
  /**
   * SchoolTerm service.
   * @module basic/api/SchoolTermApi
   * @version 0.2.0
   */

  /**
   * Constructs a new SchoolTermApi. 
   * @alias module:basic/api/SchoolTermApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 新增学期
     * @param {module:basic/model/SchoolTermCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/CreatedVo}
     */
this.add = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling add";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/school_term/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 返回全部学期
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:basic/model/SchoolTermVo>}
     */
this.list = function() {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [SchoolTermVo];
      return this.apiClient.callApi(
        '/api/school_term/list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询学期
     * @param {Integer} pageNum 当前页
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/PagingSchoolTermVo}
     */
this.page = function(pageNum) {
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling page";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingSchoolTermVo;
      return this.apiClient.callApi(
        '/api/school_term/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除管理员
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.remove = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling remove";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/school_term/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改学期
     * @param {Integer} id id
     * @param {module:basic/model/SchoolTermEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:basic/model/UpdatedVo}
     */
this.update = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling update";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling update";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/school_term/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
